const selectExpenseStatus = [
  { id: 1, name: 'Concluido' },
  { id: 2, name: 'Aberto/Pendente' },
  { id: 3, name: 'Agendado' },
];

export default selectExpenseStatus;
